import styled from '@emotion/styled'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { TabItem, Tabs } from '@duik/it'

export const Container = styled.div`
  padding: 30px 130px 20px 30px;
  display: flex;
  justify-content: space-between;
`

export const Title = styled.h3`
  font-size: 16px;
  color: #3e3f42;
`

export const Subtitle = styled.p`
  font-size: 14px;
  color: #3e3f42;
`

export const StyledTabItem = styled(TabItem)`
  height: 35px;

  &:first-of-type {
    margin-left: 0;
  }

  &.active {
    border-bottom-color: #289c91;
  }
`

export const StyledTabs = styled(Tabs)`
  padding: 0;
  border-bottom: 0px;
  margin-bottom: 20px;

  &.tabs:not(:last-child) {
    border-bottom: 0;
  }
`

export const ProjectContainer = styled.div`
  background: #eaedf380 0% 0% no-repeat padding-box;
  border: 1px solid #d8dce6;
  border-radius: 4px;
  width: 465px;
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 16px;

  &:hover,
  &.active {
    border-color: #289c91;
  }

  &.active {
    background-color: #289c91;
  }
`

export const ProjectWrapper = styled.div`
  width: 465px;
`

export const ProjectText = styled.p`
  color: #3e3f42;
  font-size: 14px;
  padding: 12px 0;

  .active & {
    color: #ffffff;
  }
`

export const ProjectsSelected = styled.p`
  font-size: 14px;
  color: #289c91;
  text-align: right;
`

export const StyledTickIcon = styled(CheckCircleIcon)`
  &.MuiSvgIcon-root {
    margin-top: 0;
    fill: #ffffff;
  }
`
